export { default as StyledImg } from "./image/StyledImg";
export { default as StyledSpan } from "./typography/StyledSpan";
